import { render } from "./Doc.vue?vue&type=template&id=4f026761&scoped=true"
import script from "./Doc.vue?vue&type=script&lang=js"
export * from "./Doc.vue?vue&type=script&lang=js"

import "./Doc.vue?vue&type=style&index=0&id=4f026761&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f026761"]])

export default __exports__